import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

// Get saved language synchronously before init
const getSavedLanguage = () => {
  try {
    const saved = localStorage.getItem('i18nextLng');
    if (saved === 'es' || saved === 'en') return saved;
  } catch (e) {}
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations }
    },
    lng: getSavedLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
